import { useContext, useMemo } from 'react';
import { AuthContext } from '../../authContext.js';
import { matchRoles } from '../../helpers/matchRoles.js';
/**
 * This hook checks if the current user's roles match the specified conditions.
 * It uses the `matchRoles` utility to evaluate the roles against the user's identity roles.
 *
 * @param roles - Roles that are required to match
 * @returns boolean indicating if the role conditions are met
 */
export const useRolesMatch = ({ roles }) => {
    const { identityRoles } = useContext(AuthContext);
    return useMemo(() => matchRoles(roles, identityRoles), [roles, identityRoles]);
};
